module.exports = __webpack_public_path__ + "static/Ecoclear_Logo_1-df0363b50ddbc462be1b0c67b387f8e4.svg";